import React, { useEffect, useState } from "react";
import "./Campaigns.css";
import config from "../../../../config";

import CampaignList from "./CampaignList";
import CreateCampaignModal from "./CreateCampaignModal";
import CampaignRuleModal from "./CampaignRuleModal";

export default function Campaigns() {

  /* =========================
     STATE
     ========================= */

  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [showCampaignModal, setShowCampaignModal] = useState(false);
  const [showRuleModal, setShowRuleModal] = useState(false);

  const [editingCampaign, setEditingCampaign] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  /* =========================
     API
     ========================= */

  const fetchCampaigns = async () => {

    try {

      setLoading(true);
      setError("");

      const response = await fetch(
        `${config.baseUrl}/admin/campaigns/summary`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch campaigns");
      }

      const data = await response.json();

      setCampaigns(Array.isArray(data) ? data : []);

    } catch (err) {

      console.error(err);
      setError(err.message || "Failed to load campaigns");
      setCampaigns([]);

    } finally {

      setLoading(false);

    }

  };

  /* =========================
     CAMPAIGN HANDLERS
     ========================= */

  const handleCreateCampaign = () => {
    setEditingCampaign(null);
    setShowCampaignModal(true);
  };

  const handleEditCampaign = (campaign) => {
    setEditingCampaign(campaign);
    setShowCampaignModal(true);
  };

  const handleCloseCampaignModal = () => {
    setShowCampaignModal(false);
    setEditingCampaign(null);
  };

  const handleCampaignSaved = () => {
    setShowCampaignModal(false);
    fetchCampaigns();
  };

  /* =========================
     RULE HANDLERS
     ========================= */

  const handleManageRules = (campaign) => {
    setSelectedCampaign(campaign);
    setShowRuleModal(true);
  };

  const handleCloseRuleModal = () => {
    setSelectedCampaign(null);
    setShowRuleModal(false);
  };

  const handleRulesSaved = () => {
    setShowRuleModal(false);
    setSelectedCampaign(null);
    fetchCampaigns();
  };

  /* =========================
     LIFECYCLE
     ========================= */

  useEffect(() => {
    fetchCampaigns();
  }, []);

  /* =========================
     LOADING
     ========================= */

  if (loading && campaigns.length === 0) {

    return (
      <div className="campaigns-page">
        <div className="loading">
          Loading campaigns...
        </div>
      </div>
    );

  }

  if (error && campaigns.length === 0) {

    return (
      <div className="campaigns-page">
        <div className="error">
          {error}
        </div>
      </div>
    );

  }

  /* =========================
     RENDER
     ========================= */

  return (

    <div className="campaigns-page">

      <div className="campaign-page-header">

        <h2>Campaigns</h2>

        <button
          className="btn-primary"
          onClick={handleCreateCampaign}
        >
          + Create Campaign
        </button>

      </div>

      {error && (
        <div className="error-inline">
          {error}
        </div>
      )}

      <CampaignList
        campaigns={campaigns}
        onEdit={handleEditCampaign}
        onManageRules={handleManageRules}

        // Future
        // onPreview={handlePreview}
        // onDelete={handleDelete}
        // onToggleStatus={handleToggleStatus}
      />

      {showCampaignModal && (
        <CreateCampaignModal
          campaign={editingCampaign}
          onClose={handleCloseCampaignModal}
          onSuccess={handleCampaignSaved}
        />
      )}

      {showRuleModal && selectedCampaign && (
        <CampaignRuleModal
          campaign={selectedCampaign}
          onClose={handleCloseRuleModal}
          onSuccess={handleRulesSaved}
        />
      )}

    </div>

  );

}